<template>
  <div ref="host" class="nexora-assistant-host"></div>
</template>

<script>
import { NEXORA_URL } from "@/constants";
import { nexoraApi } from "./api";

const SDK_SCRIPT_ID = "nexora-assistant-sdk";

// Скрывает виджет у тех, у кого нет права. Реальная защита — 403 на бэке
// (/nexora/assistant-token/): без права токен не выдаётся.
function loadSdk() {
  if (customElements.get("ai-assistant")) return Promise.resolve();

  return new Promise((resolve, reject) => {
    let script = document.getElementById(SDK_SCRIPT_ID);
    if (!script) {
      script = document.createElement("script");
      script.id = SDK_SCRIPT_ID;
      script.type = "module";
      script.src = `${NEXORA_URL}/sdk/assistant.js`;
      document.head.appendChild(script);
    }
    script.addEventListener("load", resolve, { once: true });
    script.addEventListener("error", () => reject(new Error("Nexora SDK не загрузился")), {
      once: true,
    });
  });
}

export default {
  name: "NexoraAssistant",
  data() {
    return { widget: null };
  },
  async mounted() {
    // Первый токен = проверка права. Нет токена — виджет не создаём и SDK не грузим.
    const firstToken = await nexoraApi.getToken();
    if (!firstToken || !this.$refs.host) return;

    try {
      await loadSdk();
      await customElements.whenDefined("ai-assistant");
    } catch (e) {
      console.error(e);
      return;
    }
    if (!this.$refs.host) return; // компонент уже размонтирован

    const widget = document.createElement("ai-assistant");
    widget.setAttribute("base-url", NEXORA_URL);
    widget.setTokenProvider(async () => {
      const token = await nexoraApi.getToken();
      if (!token) throw new Error("Nexora: токен не выдан");
      return token;
    });
    this.$refs.host.appendChild(widget);
    this.widget = widget;
  },
  beforeUnmount() {
    this.widget?.remove();
    this.widget = null;
  },
};
</script>
